export default {
  MOSTRAR_MAIN_MENU: (state) => {
    const estado = state;
    estado.mostrarMainMenu = !estado.mostrarMainMenu;
  },
  CAMBIAR_IS_CARGANDO: (state) => {
    const estado = state;
    estado.isCargando = !estado.isCargando;
  },
  MOSTRAR_RESPUESTA: (state, { respuesta }) => {
    const estado = state;
    estado.snackResponse = respuesta;
  },
};
